import { useEffect, useState } from "react";

/**
 * Slow-fade above-the-fold reel of the eleven Him × Her chapter portraits.
 * Split into a left (Him) column and a right (Her) column with a soft dark overlay
 * so the LOOXS logo and copy remain fully legible on top.
 */
export default function ChapterHeroReel({ chapters, interval = 5000, className = "" }) {
  const [i, setI] = useState(0);
  const count = chapters?.length || 0;
  useEffect(() => {
    if (count < 2) return;
    const id = setInterval(() => setI(n => (n + 1) % count), interval);
    return () => clearInterval(id);
  }, [count, interval]);

  if (!count) return null;
  return (
    <div className={`absolute inset-0 ${className}`}>
      {chapters.map((c, idx) => (
        <div
          key={c.roman}
          aria-hidden={idx !== i}
          className="absolute inset-0 grid grid-cols-2 transition-opacity duration-[2000ms]"
          style={{ opacity: idx === i ? 1 : 0 }}
        >
          <img src={c.male_face}   alt="" className="w-full h-full object-cover object-top" draggable="false" />
          <img src={c.female_face} alt="" className="w-full h-full object-cover object-top" draggable="false" />
        </div>
      ))}
      {/* Soft dark overlay for hero legibility */}
      <div className="absolute inset-0" style={{
        background: "linear-gradient(180deg, rgba(43,31,20,0.45) 0%, rgba(43,31,20,0.25) 40%, rgba(43,31,20,0.55) 100%)",
      }} />
    </div>
  );
}
